(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar-claude"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('announcement-claude')) {
    class AnnouncementClaude extends HTMLElement {
      connectedCallback() {
        this.msgs = Array.from(this.querySelectorAll('.ab__msg'));
        this.i = 0;
        this.delay = parseInt(this.dataset.speed, 10) || 5000;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.msgs.length > 1 && !reduce) {
          this.addEventListener('mouseenter', () => this.stop());
          this.addEventListener('mouseleave', () => this.play());
          this.addEventListener('focusin', () => this.stop());
          this.addEventListener('focusout', () => this.play());
          this.play();
        }
        this.onBlockSelect = (e) => {
          const i = this.msgs.indexOf(e.target);
          if (i > -1) { this.stop(); this.show(i); }
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);

        this.details = this.querySelector('.ab__loc');
        this.onDocClick = (e) => { if (this.details && this.details.open && !this.details.contains(e.target)) this.details.open = false; };
        this.onKey = (e) => { if (e.key === 'Escape' && this.details && this.details.open) { this.details.open = false; this.details.querySelector('summary').focus(); } };
        document.addEventListener('click', this.onDocClick);
        document.addEventListener('keydown', this.onKey);
      }
      disconnectedCallback() {
        this.stop();
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('click', this.onDocClick);
        document.removeEventListener('keydown', this.onKey);
      }
      show(i) {
        this.i = (i + this.msgs.length) % this.msgs.length;
        this.msgs.forEach((m, n) => {
          const on = n === this.i;
          m.classList.toggle('is-active', on);
          on ? m.removeAttribute('aria-hidden') : m.setAttribute('aria-hidden', 'true');
          if ('inert' in m) m.inert = !on;
        });
      }
      play() { this.stop(); this.timer = setInterval(() => this.show(this.i + 1), this.delay); }
      stop() { clearInterval(this.timer); }
    }
    customElements.define('announcement-claude', AnnouncementClaude);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider-claude"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hero-slider-claude')) {
    class HeroSliderClaude extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.hc__track');
        this.slides = Array.from(this.querySelectorAll('.hc__slide'));
        this.dots = Array.from(this.querySelectorAll('[data-hc-go]'));
        this.prevBtn = this.querySelector('[data-hc-prev]');
        this.nextBtn = this.querySelector('[data-hc-next]');
        this.count = this.slides.length;
        this.index = 0;
        this.delay = parseInt(this.dataset.speed, 10) || 6000;
        this.loop = this.dataset.loop === 'true';
        this.fade = this.dataset.transition === 'fade';
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true' && this.count > 1 && !reduce && !window.Shopify?.designMode;
        this.remaining = this.delay;
        if (this.autoplay) this.classList.add('is-autoplay');

        this.onPrev = () => { this.go(this.index - 1); };
        this.onNext = () => { this.go(this.index + 1); };
        this.prevBtn?.addEventListener('click', this.onPrev);
        this.nextBtn?.addEventListener('click', this.onNext);
        this.dots.forEach((d) => d.addEventListener('click', () => this.go(parseInt(d.dataset.hcGo, 10))));

        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.onPrev(); }
          if (e.key === 'ArrowRight') { e.preventDefault(); this.onNext(); }
        });

        // Swipe
        let x0 = null, y0 = null;
        this.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
        this.addEventListener('touchend', (e) => {
          if (x0 === null) return;
          const dx = e.changedTouches[0].clientX - x0;
          const dy = e.changedTouches[0].clientY - y0;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) dx < 0 ? this.onNext() : this.onPrev();
          x0 = y0 = null;
        }, { passive: true });

        // Pause
        if (this.autoplay) {
          if (this.dataset.pauseHover === 'true') {
            this.addEventListener('mouseenter', () => this.pause());
            this.addEventListener('mouseleave', () => this.resume());
          }
          this.addEventListener('focusin', () => this.pause());
          this.addEventListener('focusout', (e) => { if (!this.contains(e.relatedTarget)) this.resume(); });
          this.onVisibility = () => (document.hidden ? this.pause() : this.resume());
          document.addEventListener('visibilitychange', this.onVisibility);
        }

        // Éditeur de thème
        this.onBlockSelect = (e) => {
          if (e.detail.sectionId !== this.dataset.sectionId) return;
          const i = this.slides.indexOf(e.target);
          if (i > -1) this.go(i, false);
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);

        this.go(0, false);
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
      }

      go(i, animate = true) {
        if (!this.count) return;
        if (i < 0) i = this.loop ? this.count - 1 : 0;
        if (i >= this.count) i = this.loop ? 0 : this.count - 1;
        this.index = i;

        if (!this.fade) {
          this.track.style.transition = animate ? '' : 'none';
          this.track.style.transform = `translateX(${-100 * i}%)`;
          if (!animate) { void this.track.offsetWidth; this.track.style.transition = ''; }
        }

        this.slides.forEach((slide, n) => {
          const active = n === i;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          if ('inert' in slide) slide.inert = !active;
          const video = slide.querySelector('video');
          if (video) active ? video.play().catch(() => {}) : video.pause();
        });

        this.dots.forEach((dot, n) => {
          dot.classList.toggle('is-active', n === i);
          dot.classList.remove('is-running');
          n === i ? dot.setAttribute('aria-current', 'true') : dot.removeAttribute('aria-current');
        });

        if (!this.loop) {
          if (this.prevBtn) this.prevBtn.disabled = i === 0;
          if (this.nextBtn) this.nextBtn.disabled = i === this.count - 1;
        }

        if (this.autoplay) this.start();
      }

      start() {
        clearTimeout(this.timer);
        this.remaining = this.delay;
        const dot = this.dots[this.index];
        if (dot) { void dot.offsetWidth; dot.classList.add('is-running'); }
        if (!this.paused) this.schedule();
      }

      schedule() {
        clearTimeout(this.timer);
        this.startedAt = Date.now();
        this.timer = setTimeout(() => {
          if (!this.loop && this.index === this.count - 1) this.go(0);
          else this.go(this.index + 1);
        }, this.remaining);
      }

      pause() {
        if (this.paused) return;
        this.paused = true;
        this.classList.add('is-paused');
        clearTimeout(this.timer);
        this.remaining = Math.max(0, this.remaining - (Date.now() - this.startedAt));
      }

      resume() {
        if (!this.paused) return;
        this.paused = false;
        this.classList.remove('is-paused');
        this.schedule();
      }
    }
    customElements.define('hero-slider-claude', HeroSliderClaude);
  }

  } catch(e) { console.error(e); }
})();
})();
